import * as React from "react";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";

import {
  BasicPropertyOffers,
  PropertyLevelOffersMessage,
  PropertyOffers as SharedUiPropertyOffers,
} from "@shared-ui/lodging-property-offers";

import { RefTarget } from "@shared-ui/ref-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";

import { UitkSpacing } from "uitk-react-spacing";
import { ComponentProps, FTNodeOptions } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { StackedSticky } from "components/shared/StackedSticky/StackedSticky";

import { DesktopForm, MobileForm } from "components/shared/DatePickerAndTravelerForm/Form";
import { FlexModuleModelStore } from "stores/FlexModuleModelStore";

const WrappedPropertyOffers = PropertyBexApiWrapper(SharedUiPropertyOffers);
const WrappedBasicPropertyOffers = PropertyBexApiWrapper(BasicPropertyOffers);
const WrappedPropertyOffersMessage = PropertyBexApiWrapper(PropertyLevelOffersMessage);

interface PropertyOffersOptions extends FTNodeOptions {
  hideSearchForm?: boolean;
}

export interface PropertyOffersProps extends ComponentProps {
  flexModuleModelStore: FlexModuleModelStore;
}

export const PropertyOffers = withStores("flexModuleModelStore")((props: PropertyOffersProps) => {
  const { context, flexModuleModelStore, flexTemplateNode } = props;

  const id = flexTemplateNode?.id || "";

  /* istanbul ignore if */
  if (!flexTemplateNode) {
    return null;
  }

  const model = flexModuleModelStore?.getModel(id);
  const options = normalizeOptionsData(flexTemplateNode, model) as PropertyOffersOptions;
  const hideSearchForm = options?.hideSearchForm;

  return (
    <UitkSpacing
      margin={{ blockend: "three", blockstart: "six" }}
      padding={{ small: { inline: "three" }, medium: { inline: "unset" } }}
      className="PropertyOffers"
    >
      <RefTarget name="Offers" tag="section" dataStid="section-hotel-search">
        <UitkSpacing margin={{ blockend: "two" }}>
          <WrappedPropertyOffersMessage context={context} />
        </UitkSpacing>
        {!hideSearchForm && (
          <WrappedPropertyOffers context={context}>
            <SharedUiPropertyOffers.Form>
              <Viewport>
                <ViewSmall>
                  <MobileForm context={context} />
                </ViewSmall>
                <ViewMedium>
                  <StackedSticky padded>
                    <DesktopForm context={context} />
                  </StackedSticky>
                </ViewMedium>
              </Viewport>
            </SharedUiPropertyOffers.Form>
          </WrappedPropertyOffers>
        )}

        {hideSearchForm && <WrappedBasicPropertyOffers context={context} />}
      </RefTarget>
    </UitkSpacing>
  );
});

export default PropertyOffers;
